import { render, staticRenderFns } from "./QuestionCheckbox.vue?vue&type=template&id=161184d8&scoped=true"
import script from "./QuestionCheckbox.vue?vue&type=script&lang=js"
export * from "./QuestionCheckbox.vue?vue&type=script&lang=js"
import style0 from "./QuestionCheckbox.vue?vue&type=style&index=0&id=161184d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161184d8",
  null
  
)

export default component.exports